const UiIconPropsOption = { name: String };
const UiIconEmits = {
  click: (_ev) => true
};

export { UiIconEmits, UiIconPropsOption };
//# sourceMappingURL=index.mjs.map
